import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IDataRespInfo } from 'src/app/services/data/generico/generico.model';

@Component({
  selector: 'app-modal-response',
  templateUrl: './modal-response.component.html',
  styleUrls: ['./modal-response.component.scss'],
})
export class ModalResponseComponent implements OnInit {
  nameIcon = "";

  constructor(
    public dialogRef: MatDialogRef<ModalResponseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDataRespInfo
  ) { }

  ngOnInit(): void {
    switch (this.data.type) {
      case "SUCCESS": this.nameIcon = "check-circle"; break;
      case "ERROR": this.nameIcon = "exclam"; break;
      default: break;
    }
  }

  btnAction() {
    this.dialogRef.close();
  }
}
